(function () {
  'use strict';
  var config = window.MunchiesReviewImages;
  if (!config || !config.groups || !config.groups.length) return;
  var names = {}, controls = new WeakMap(), dialog;
  config.groups.forEach(function (group) {
    group.source_filenames.concat([group.original_filename]).forEach(function (name) { names[name] = group; });
  });
  function groupFor(image) {
    var url = image.getAttribute('src') || image.getAttribute('data-src');
    if (!url) return;
    try {
      var name = decodeURIComponent(new URL(url, document.baseURI).pathname.split('/').pop());
      var resized = name.match(/^(.*)_\d+x(?:\d+)?(\.[^.]+)$/);
      return names[name] || (resized && names[resized[1] + resized[2]]);
    } catch (_) { return; }
  }
  function element(tag, text, className) {
    var node = document.createElement(tag);
    if (text) node.textContent = text;
    if (className) node.className = className;
    return node;
  }
  function open(group, trigger) {
    if (!dialog) {
      dialog = element('dialog', '', 'mx-review-image-dialog');
      dialog.setAttribute('aria-labelledby', 'mx-review-image-heading');
      document.body.appendChild(dialog);
      dialog.addEventListener('click', function (event) { if (event.target === dialog) dialog.close(); });
    }
    dialog.replaceChildren();
    var close = element('button', '×', 'mx-review-image-close');
    close.type = 'button'; close.setAttribute('aria-label', config.labels.close);
    close.addEventListener('click', function () { dialog.close(); });
    var heading = element('h2', config.labels.heading); heading.id = 'mx-review-image-heading';
    dialog.appendChild(close); dialog.appendChild(heading);
    dialog.appendChild(element('p', config.labels.translated_notice, 'mx-review-image-notice'));
    (group.headings || []).forEach(function (text) { dialog.appendChild(element('p', text, 'mx-review-image-graphic-heading')); });
    group.reviews.forEach(function (review) {
      var card = element('figure', '', 'mx-review-image-card');
      var caption = element('figcaption', review.author || '');
      if (review.rating) caption.appendChild(element('span', ' · ' + review.rating + '/5'));
      card.appendChild(caption);
      if (review.metadata) card.appendChild(element('p', review.metadata, 'mx-review-image-notice'));
      card.appendChild(element('blockquote', review.translation || review.original));
      if (review.excerpt) card.appendChild(element('p', review.excerpt, 'mx-review-image-notice'));
      dialog.appendChild(card);
    });
    (group.other_text || []).forEach(function (text) { dialog.appendChild(element('p', text, 'mx-review-image-notice')); });
    dialog.onclose = function () { if (trigger.isConnected) trigger.focus(); };
    dialog.showModal();
  }
  function update(image) {
    if (!image || image.nodeType !== 1 || image.tagName !== 'IMG') return;
    var group = groupFor(image), old = controls.get(image);
    if (!group || !group.reviews.length) { if (old) { old.remove(); controls.delete(image); } return; }
    if (image.closest('[class*="thumb"], [data-thumbs], [data-thumbnail], .mx-review-image-dialog')) return;
    if (image.getAttribute('role') === 'presentation' || image.getAttribute('aria-hidden') === 'true') return;
    if (old && old.isConnected) { old.mxReviewGroup = group; return; }
    var interactive = image.closest('button,a'), anchor = interactive || image;
    var button = element('button', config.labels.show_translation, 'mx-review-image-translate');
    button.type = 'button'; button.mxReviewGroup = group;
    button.setAttribute('aria-haspopup', 'dialog');
    button.addEventListener('click', function (event) {
      event.preventDefault(); event.stopPropagation(); open(button.mxReviewGroup, button);
    });
    var slide = image.closest('.ms-gal__slide');
    if (slide) { slide.style.position = 'relative'; button.classList.add('mx-review-image-overlay'); slide.appendChild(button); }
    else anchor.insertAdjacentElement('afterend', button);
    controls.set(image, button);
  }
  function scan(root) {
    update(root);
    if (root.querySelectorAll) root.querySelectorAll('img').forEach(update);
  }
  function start() {
    scan(document);
    new MutationObserver(function (changes) {
      changes.forEach(function (change) {
        if (change.type === 'attributes') update(change.target);
        else change.addedNodes.forEach(scan);
      });
    }).observe(document.documentElement, {subtree: true, childList: true, attributes: true, attributeFilter: ['src', 'data-src']});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
}());
